__turbopack_context__.v({
  "actionButtons": "EventSignalsBar-module-scss-module__g3nmKG__actionButtons",
  "container": "EventSignalsBar-module-scss-module__g3nmKG__container",
  "innerWrapper": "EventSignalsBar-module-scss-module__g3nmKG__innerWrapper",
  "signals": "EventSignalsBar-module-scss-module__g3nmKG__signals",
});
